import './VentilatorSetParamsMobileView.scss'

function VentilatorSetParamsMobileView({ params }) {
    return (
        <div className="vital-footer-container-mobile-view">
            <div className="vital-footer-container-mobile-view-title">
                Set Parameters
            </div>

            <div className="vital-footer-container-mobile-view-set-params-container">
                {params.map((item, index) => (
                    <div className="set-param-card" key={index}>
                        <div className="set-param-title">{item.title}</div>
                        <div className="set-param-value">{item.value}</div>
                        <div className="set-param-unit">{item.unit}</div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default VentilatorSetParamsMobileView;